export const REACT_APP_ENV = 'production';
export const REACT_APP_SITE_KEY_LOCAL = '6LfJn4kUAAAAAJXyerpLzi2ql3yz90SCmdDECQRj';
export const  REACT_APP_SITE_KEY_PRODUCTION = '6Ld7q1kjAAAAAJejLYO_qlUtU--vPcjTotdiPBEn';